import { Field, ErrorMessage } from 'formik';
import { useEffect } from 'react';
import InfoAlert from '../../../../../components/commonLayouts/Alert/InfoAlert';
import PropertyFormat, {
    amountFormat,
} from '../../../../../components/commonLayouts/PropertyFormat/PropertyFormat';
import DeaValueCalUI from '../DealValueCalUI';
import { useDispatch, useSelector } from 'react-redux';
import { getDealCalculation } from '../../../../../redux/actions/transactionApi';
import { useDebounce } from '../DebouncedValue';
import { getFilteredEarlyPaymentOptions } from '../../../../../utils/paymentTermUtils';
import CodEarlyPaymentInfoIcon from '../../../../../components/commonLayouts/CodEarlyPaymentInfoIcon/CodEarlyPaymentInfoIcon';
import { buildDealCalculationPayload } from '../RequestFinancing.helpers';

const ExtendedCreditAndServices = (props) => {
    const state = useSelector((state) => {
        return state.app;
    });
    const dispatch = useDispatch();
    const debouncedProducts = useDebounce(props.formikProps.values.products, 500);
    const debouncedCharges = useDebounce(props.formikProps.values.products, 500);

    useEffect(() => {
        const payload = buildDealCalculationPayload({
            platformRole: props.platformRole,
            orgId: props.orgId,
            associatedBuyer: props.associatedBuyer,
            buyerSupplierName: props.formikProps.values.buyer_supplier_name,
            products: debouncedProducts,
            charges: debouncedCharges,
            paymentTerm: props.formikProps.values.payment_term,
            earlyPayment: props.formikProps.values.early_payment_options,
            extendedCredit: props.formikProps.values.extended_credit_option,
            checked: props.formikProps.values.checked,
            transactionType: state?.transaction?.item?.transaction_type || 'deal_financing',
            chargeProductNameKey: 'name',
        });
        payload.role = props?.platformRole;

        dispatch(getDealCalculation(payload));
        props.calculateTotalDealValue(props.formikProps.values);
    }, [debouncedProducts, debouncedCharges, props.platformRole]);
    return (
        <div className='accordion-item'>
            <h2 className='accordion-header' id='flush-headingSix'>
                <button
                    className='accordion-button collapsed accordion-title px-3'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#flush-collapseSix'
                    aria-expanded='false'
                    aria-controls='flush-collapseSix'>
                    {props.role === 'buyer' ? 'Extended Credit & Additional Services' : 'Financing Options'}
                </button>
            </h2>
            <div
                id='flush-collapseSix'
                className='accordion-collapse collapse show'
                aria-labelledby='flush-headingSix'
                data-bs-parent='#accordionFlushExample'>
                <div className='accordion-body p-0 px-1 pb-4'>
                    <div className='row m-0'>
                        <div className='col-12 px-4 mt-2'>
                            <p className='font-b3 text-neutral-800 mb-2 text-start'>
                                {' '}
                                {(props.role === 'buyer' || props.role === 'broker') && 'Extended Credit Options'}
                                {props.role === 'supplier' && 'Trade Support Options'}
                            </p>
                            <div className='row m-0'>
                                {(props.role === 'buyer' || props.role === 'broker') && (
                                    <>
                                        <div className='col-12 col-md-4 text-start p-0'>
                                            <div role='group' aria-labelledby='extended_credit_option_group'>
                                                <div className='col-12 font-b2'>
                                                    <div className='form-check'>
                                                        <label>
                                                            <Field
                                                                type='radio'
                                                                name='extended_credit_option'
                                                                value='not_needed'
                                                                className='form-check-input'
                                                            />
                                                            Not Needed
                                                        </label>
                                                    </div>
                                                    <div className='form-check'>
                                                        <label>
                                                            <Field
                                                                type='radio'
                                                                name='extended_credit_option'
                                                                value='15_days'
                                                                className='form-check-input'
                                                            />
                                                            15 Days
                                                        </label>
                                                    </div>
                                                    <div className='form-check'>
                                                        <label>
                                                            <Field
                                                                type='radio'
                                                                name='extended_credit_option'
                                                                value='30_days'
                                                                className='form-check-input'
                                                            />
                                                            30 Days
                                                        </label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <label>
                                                            <Field
                                                                type='radio'
                                                                name='extended_credit_option'
                                                                value='45_days'
                                                                className='form-check-input'
                                                            />
                                                            45 Days
                                                        </label>
                                                    </div>
                                                    <div className='form-check'>
                                                        <label>
                                                            <Field
                                                                type='radio'
                                                                name='extended_credit_option'
                                                                value='60_days'
                                                                className='form-check-input'
                                                            />
                                                            60 Days
                                                        </label>
                                                    </div>

                                                    {props.formikProps.values.payment_term !== '21_days' &&
                                                        props.formikProps.values.payment_term !== '30_days' && (
                                                            <div className='form-check'>
                                                                <label>
                                                                    <Field
                                                                        type='radio'
                                                                        name='extended_credit_option'
                                                                        value='75_days'
                                                                        className='form-check-input'
                                                                    />
                                                                    75 Days
                                                                </label>
                                                            </div>
                                                        )}
                                                    {props.formikProps.values.payment_term !== '7_days' &&
                                                        props.formikProps.values.payment_term !== '14_days' &&
                                                        props.formikProps.values.payment_term !== '21_days' &&
                                                        props.formikProps.values.payment_term !== '30_days' && (
                                                            <div className='form-check'>
                                                                <label>
                                                                    <Field
                                                                        type='radio'
                                                                        name='extended_credit_option'
                                                                        value='90_days'
                                                                        className='form-check-input'
                                                                    />
                                                                    90 Days
                                                                </label>
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6 text-start p-0'>
                                            <p className='font-b3 text-neutral-800 mb-2'>Choose services</p>
                                            <div role='group' aria-labelledby='services-group'>
                                                <label className='font-b2'>
                                                    <Field
                                                        type='checkbox'
                                                        name='checked'
                                                        value='trade'
                                                        className='form-check-input'
                                                    />{' '}
                                                    &nbsp; Trade Ops
                                                </label>
                                                <br />
                                                <label className='font-b2'>
                                                    <Field
                                                        type='checkbox'
                                                        name='checked'
                                                        value='disputeClaim'
                                                        className='form-check-input'
                                                    />{' '}
                                                    &nbsp;Dispute & Claims Management
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {props.role === 'supplier' && (
                                    <div className='col-12 col-md-12 text-start p-0'>
                                        <div role='group' aria-labelledby='early_payment_options_group'>
                                            <div className='col-12 font-b2'>
                                                {getFilteredEarlyPaymentOptions(
                                                    props.formikProps.values.payment_term,
                                                ).map((opt) => (
                                                    <div key={opt.value} className='form-check'>
                                                        <label>
                                                            <Field
                                                                type='radio'
                                                                name='early_payment_options'
                                                                value={opt.value}
                                                                className='form-check-input'
                                                            />
                                                            {opt.label}
                                                            {opt.value === '3_days' &&
                                                                props.formikProps.values.early_payment_options ===
                                                                '3_days' && <CodEarlyPaymentInfoIcon />}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <DeaValueCalUI props={props} />
                                {props.totalDealVal > state.userMang.buyerStats.market_credit_balance &&
                                    props.role === 'buyer' && (
                                        <div className='col-12 col-md-12 text-start p-0'>
                                            <InfoAlert
                                                type='warning'
                                                title={`Credit limit exceeded. Available credit limit is ${PropertyFormat(
                                                    state.userMang.buyerStats.market_credit_balance,
                                                    amountFormat
                                                )}`}
                                            />
                                            <div role='group' aria-labelledby='services-group'>
                                                <label className='font-b2'>
                                                    <Field
                                                        type='checkbox'
                                                        name='settle_exceeded_credit'
                                                        value='spot_credit'
                                                        className='form-check-input'
                                                        checked={
                                                            props.formikProps?.values?.settle_exceeded_credit ===
                                                            'spot_credit'
                                                        }
                                                        onChange={(e) => {
                                                            props.formikProps.setFieldValue(
                                                                'settle_exceeded_credit',
                                                                e.target.checked ? 'spot_credit' : 'not_needed'
                                                            );
                                                        }}
                                                    />{' '}
                                                    &nbsp; Request Spot Credit
                                                </label>
                                            </div>
                                        </div>
                                    )}
                                {props.role === 'supplier' && (
                                    <>
                                        {props.buyerTradeLimit
                                            ? props.totalDealVal > props.buyerTradeLimit && (
                                                <div className='col-12 col-md-12 text-start p-0'>
                                                    <InfoAlert
                                                        title={`Warning: The Buyer's Buyer Trade limit has been exhausted.
                                                        You may proceed with raising the financing request. However, to avoid potential issues during transaction processing, please contact the 129 Knots team to enhance the Buyer's Buyer Trade limit.`}
                                                        type="warning"
                                                    />
                                                </div>
                                            )
                                            : props.totalDealVal >
                                            state?.userMang?.supplierStats
                                                ?.early_payment_facility_balance_amount && (
                                                <div className='col-12 col-md-12 text-start p-0'>
                                                    <InfoAlert
                                                        type='warning'
                                                        title={`Early Credit balance exceeded. Available credit limit is ${PropertyFormat(
                                                            state.userMang.supplierStats
                                                                .early_payment_facility_balance_amount,
                                                            amountFormat
                                                        )}`}
                                                    />
                                                </div>
                                            )}
                                    </>
                                )}

                                <div className='col-12 col-md-8 my-4 p-0 text-start'>
                                    <label className='form-label text-neutral-800 font-b3 mb-1 w-100'>
                                        Deal Specific Terms (T&Cs)
                                        <span className='float-end font-b3'>
                                            {`${props.formikProps.values.deal_specific_agreements?.length || 0}/255`}
                                        </span>
                                    </label>
                                    <Field
                                        className='form-control form-control-sm'
                                        as='textarea'
                                        id='deal_specific_agreements'
                                        name='deal_specific_agreements'
                                        maxLength={255}
                                        rows='3'></Field>
                                    <ErrorMessage
                                        name={`deal_specific_agreements`}
                                        component='div'
                                        className='error-message font-b4 text-error-700'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExtendedCreditAndServices;
